import React, { useMemo } from "react";
import { toCSV, downloadCsv } from "./utils/csv";

export default function TableView({
  title = "",
  rows = [],
  columns,                // optional canonical header order
  showExport = false,     // keep false; Reports owns exporting
}) {
  const headers = useMemo(() => {
    if (columns && columns.length) return columns; // show canonical order even if no rows
    if (!rows || rows.length === 0) return [];
    return Array.from(new Set(rows.flatMap((r) => Object.keys(r))));
  }, [rows, columns]);

  const onExport = () => {
    if (!rows?.length) {
      alert("No rows to export");
      return;
    }
    const csv = toCSV(headers, rows);
    const fname = (title || "data").replace(/\s+/g, "_").toLowerCase();
    downloadCsv(`${fname}.csv`, csv);
  };

  return (
    <div style={{ marginTop: 12 }}>
      {showExport && (
        <div style={{ marginBottom: 8 }}>
          <button onClick={onExport}>Export CSV</button>
        </div>
      )}

      <div style={{ overflowX: "auto" }}>
        <table style={{ borderCollapse: "collapse", minWidth: 900 }}>
          <thead>
            <tr>
              {headers.map((h) => (
                <th
                  key={h}
                  style={{ textTransform: "none", textAlign: "left", padding: "6px 8px", borderBottom: "1px solid #ddd" }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((r, i) => (
              <tr key={i}>
                {headers.map((h) => (
                  <td key={h + i} style={{ padding: "6px 8px", borderBottom: "1px solid #f0f0f0" }}>
                    {String(r[h] ?? "")}
                  </td>
                ))}
              </tr>
            ))}
            {!rows?.length && (
              <tr>
                <td colSpan={headers.length || 1} style={{ padding: 12, textAlign: "center", color: "#666" }}>
                  No records yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}